import type { ReactionKind } from "./ability";
import { FIGHTER, type FighterState } from "./state";

/**
 * Вид реакции на удар по состоянию бойца — одно правило для мира (зона попадания идёт за телом, sim/combat.ts) и для
 * картинки (клип реакции, render/sprites/animation.ts). Сильный удар (долгое оглушение, сила) — шаги назад;
 * в голову — голова откидывается; иначе — корпус сгибается; в воздухе — отлёт или подсечка.
 */
export const HEAVY_STUN = 18;

export function reactionKind(fighter: FighterState): ReactionKind | null {
  if (fighter.state === FIGHTER.airHit) return fighter.fallKind === 1 ? "trip" : "air";
  if (fighter.state !== FIGHTER.hitstun) return null;
  // вид решён силой удара и держится всю реакцию: оглушение убывает по кадру — берём его на миг удара (остаток плюс
  // прошедшие кадры); отброс гаснет — по нему вид переключался бы посреди реакции (и клип, и зона попадания прыгали)
  if (fighter.stun + fighter.stateFrame >= HEAVY_STUN || fighter.hurtPower >= 2) return "stumble";
  return fighter.hurtSpot === 1 ? "head" : "body";
}

/** Смещение корпуса от места мира в реакции, пиксели вперёд по взгляду (0 — нет таблицы или не реакция). */
export function reactionLean(
  fighter: FighterState,
  table: Readonly<Record<ReactionKind, readonly number[]>> | undefined,
): number {
  const kind = reactionKind(fighter);
  if (!kind || !table) return 0;
  const frames = table[kind];
  return frames[Math.min(frames.length - 1, Math.max(0, fighter.stateFrame))] ?? 0;
}
